// extracted by mini-css-extract-plugin
export default {"table":"styles_table__GaryG","tr":"styles_tr__ibQE6","td":"styles_td__0qxr1","th":"styles_th__wW8hv"};